/**
 * 栏目 02 内容（未测算状态）
 *
 * 不同阶段下的呈现：
 *  - 公告未发布：警告 + 用往年数据演练
 *  - 公告已发布：主测算按钮 + 一句价值说明
 */
import type { StageInfo } from '@/domain/stage'
import { track } from '@/lib/track'

export function ScoreAnalysisSection({
  stageInfo,
  onCalculate
}: {
  stageInfo: StageInfo
  onCalculate: () => void
}) {
  const { canCalculate, stage } = stageInfo
  const isBeforeScore =
    stage === 'pre_exam' || stage === 'near_exam' || stage === 'in_exam' || stage === 'wait_score'

  return (
    <div className="card">
      <div className="text-ink-800 mb-3 leading-relaxed">
        输入分数，<strong>3 秒</strong>得到邹城五校的录取概率区间与「冲 / 稳 / 保」建议。
      </div>

      <ul className="text-ink-600 text-sm space-y-1.5 mb-5 leading-relaxed">
        <li>· 基于官方公开数据（资格线 / 前 300 线 / 五校比例 / 分段表）</li>
        <li>· 全部计算在你的手机本地完成，不上传分数</li>
        <li>· 配套「冲 / 稳 / 保」建议与 6 项专业指标</li>
      </ul>

      {canCalculate ? (
        <>
          {isBeforeScore ? (
            <div className="px-3.5 py-3 bg-paper-100 border border-ink-200 rounded-xl text-ink-700 text-sm mb-3 leading-relaxed">
              今年官方分段表尚未发布。
              可先用 <strong className="text-brand-800">2025 年</strong>数据演练一次，
              分段表发布并录入后再以 2026 年数据复测。
            </div>
          ) : null}
          <button
            onClick={() => {
              track('drill_click', { target: 'open_wizard', from: 'score_analysis_section', stage: stageInfo.stage })
              onCalculate()
            }}
            className="btn-primary w-full py-3.5 text-h3"
          >
            {isBeforeScore ? '用 2025 年数据演练' : '输入分数 · 开始测算'}
          </button>
        </>
      ) : (
        <div className="px-3.5 py-3 bg-amber-50 border border-amber-200 rounded-xl text-amber-800 text-sm leading-relaxed">
          今年中考分数已出，正在等待官方分段表发布，暂无法进行 2026 版正式测算。
          可先查看「01 历年录取信息」，了解历年录取规律。
        </div>
      )}
    </div>
  )
}
